import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.createForm.${key}`;
const CreateFormButton = ({
  hasPermission = false,
  onClick = () => {},
  use = 'tertiary'
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('noWriteAccess')
    }),
    disabled: hasPermission,
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-selenium": "create-resource-button",
      size: "sm",
      use: use,
      block: true,
      onClick: onClick,
      disabled: !hasPermission,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('label')
      })
    })
  });
};
export default CreateFormButton;